import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import CommissionTreePage from './pages/CommissionTreePage';
import TopSalesPage from './pages/TopSalesPage';
import TotalSalesPage from './pages/TotalSalesPage';
import TotalSalesPeoplePage from './pages/TotalSalesPeoplePage';
import SalesRankPage from './pages/SalesRankPage';
import FramePage from './pages/FramePage';

import NotFoundPage from './pages/NotFoundPage'
import SingleSignonPage from './pages/SingleSignonPage'

import BIPage from './pages/BIPage';
import SalesPerformance from './pages/SalesPerformance';
import { useEffect } from "react";

function App() {
  const viewFromAgentId = useSelector(state => state.viewFromAgentId);

  // useEffect(() => {
  //   console.log(viewFromAgentId)
  // }, [viewFromAgentId])

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/" component={NotFoundPage} />         
          {/* team leader */}
          {/* sit-commissiontree.iproforma.com/agents/commissionTreeSignon/oNTZnYi7E4wvnOn2oNyaMxz7CenVCdxZ4OWQy5xj8DWOsad8hbkGRAlKaIOBXFSZ */} 
          {/* agent with downline */}
          {/* sit-commissiontree.iproforma.com/agents/commissionTreeSignon/wTBTVf5mgkNef8nCeb335WQzKKn9a8MnYLZatgd2xgHrMY79PndcuhjfeOmOjjV8 */} 
          
          <Route exact path="/agents/commissionTreeSignon/:key" component={SingleSignonPage} />
          {viewFromAgentId ?
            <Switch>
              <Route exact path="/dashboard" component={CommissionTreePage} />
              <Route exact path="/topsales" component={TopSalesPage} />
              <Route exact path="/totalsales" component={TotalSalesPage} />
              <Route exact path="/totalsalespeople" component={TotalSalesPeoplePage} />
              <Route exact path="/salesrank" component={SalesRankPage} />
              <Route exact path="/:type" component={FramePage} />

              <Route exact path="/bi" component={BIPage} />
              <Route exact path="/salesperformance" component={SalesPerformance} />
              <Route component={NotFoundPage} />
            </Switch> :
            <Redirect to="/" />
          }
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
